import { render, staticRenderFns } from "./TwoColumnContentBlock.vue?vue&type=template&id=2265e78b&scoped=true&"
import script from "./TwoColumnContentBlock.vue?vue&type=script&lang=js&"
export * from "./TwoColumnContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnContentBlock.vue?vue&type=style&index=0&id=2265e78b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265e78b",
  null
  
)

export default component.exports